var map = {
	"./tx-1.png": "qscF",
	"./tx-10.png": "a3WN",
	"./tx-11.png": "sVbz",
	"./tx-12.png": "SlGH",
	"./tx-13.png": "OgIj",
	"./tx-2.png": "kw3h",
	"./tx-3.png": "PEdW",
	"./tx-4.png": "9fDZ",
	"./tx-5.png": "hLWo",
	"./tx-6.png": "d3/1",
	"./tx-7.png": "50Hw",
	"./tx-8.png": "3H29",
	"./tx-9.png": "ha0P"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Ot5c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/tx\-.*\.png$
// module id = Ot5c
// module chunks = 1